import { useTranslation } from 'react-i18next'
import { TipsterAppTourModal } from '@app/ui'
import env from '@app/environment'
import { useOnboardingData } from '../UserOnboarding/hooks/useOnboardingData'
import { WelcomeModal } from './components/WelcomeModal'
import { VideoTourFooter } from './components/VideoTourFooter'
import { CompletionModal } from './components/CompletionModal'
import { useTipsterOnboarding } from './hooks/useTipsterOnboarding'

const tourWelcomePoints = [
  { msg: 'tipstertour.step.sub1', icon: '⚙️' },
  { msg: 'tipstertour.step.sub2', icon: '🚀' },
  { msg: 'tipstertour.step.sub3', icon: '🤝' },
  { msg: 'tipstertour.step.sub4', icon: '🧠' },
  { msg: 'tipstertour.step.sub5', icon: '⚡' },
]

export const TipsterOnboarding = ({
  onClose
}: {
  onClose: (update: boolean) => void
}) => {
  const { t } = useTranslation()
  const {
    isTouring,
    isTipster,
    tourStage,
    currentTourStage,
    username,
    showBasicVideo,
    showWelcome,
    handlers
  } = useTipsterOnboarding(onClose)

  const { welcomeIcon } = useOnboardingData()

  if (isTouring && isTipster && currentTourStage !== 'userInviteMenu' && currentTourStage !== 'userCompletedOnboarding') {
    return (
      <TipsterAppTourModal
        open={showBasicVideo}
        onClose={handlers.handleCloseModal}
        title={t('basics.title')}
        sub={t('basics.sub.title')}
        nextButtonLabel={t('usertour.step1.page.button')}
        videoLink={env.TIPSTER_APP_TOUR_BASIC_EXPLAINER_VIDEO}
        onNext={handlers.handleVideoNext}
        onSkip={handlers.handleSkip}
      >
        <>
          {!tourStage.basicWelcome && (
            <WelcomeModal
              open={showWelcome}
              username={username}
              tourWelcomePoints={tourWelcomePoints}
              welcomeIcon={welcomeIcon}
              onNext={handlers.handleWelcomeNext}
            />
          )}
          <VideoTourFooter
            body1="basics.body1"
            body2="basics.body2"
            body3="basics.body3"
          />
        </>
      </TipsterAppTourModal>
    )
  }

  if (isTouring && isTipster && currentTourStage === 'userCompletedOnboarding') {
    return (
      <TipsterAppTourModal
        open={true}
        onClose={handlers.handleCloseModal}
        title={t('basics.title')}
        sub={t('basics.sub.title')}
        hideNextSkip={true}
        videoLink={env.TIPSTER_APP_TOUR_BASIC_EXPLAINER_VIDEO}
      >
        <>
          <CompletionModal onComplete={handlers.handleCompleteOnboarding} />
          <VideoTourFooter
            body1="basics.body1"
            body2="basics.body2"
            body3="basics.body3"
          />
        </>
      </TipsterAppTourModal>
    )
  }

  return null
}